import React, { useEffect, useState } from "react"
import { useScope } from "../SelectProjectCompanyContainer"
import { useDWOptions } from "../../core/utils/hooks/useDwOptions"
import { formartDataToFix, formatCharts } from "../../core/utils/fixedItens"
import Send from "../../core/communication"
import AssistanceAnalysisScreen from "../../screen/AssistanceAnalysisScreen"
import { getDwContentData } from "../../core/utils/hooks/useDwContentData"
import { useNavigate } from "react-router-dom"
import { useForm } from "react-hook-form"
import { isValidURL } from "../../core/utils/validateFields"
import { sort } from "fast-sort"
import useGCPSuggestions from "../../core/utils/hooks/useCGPSuggestions"
import { useDispatch } from "react-redux"
import { setData } from "../../core/redux/app/Actions"
import { useSelector } from "react-redux"
import { customToast } from "../../components/Toast"

export const clearFields = (resetField) => {
  resetField("linkImage", { keepError: false })
  resetField("order", { keepError: false })
  resetField("description", { keepError: false })
  resetField("title", { keepError: false })
}

const AssistanceAnalysisContainer = () => {
  const [dw] = useDWOptions()
  const { scope, scopeType } = useScope()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const reportPathListSelectedId = useSelector((state) => state.app.reportPathListSelectedId)
  const loadOptions = useGCPSuggestions()

  const [value, setValue] = useState("")
  const [questionValue, setQuestionValue] = useState("")
  const [clusteredTitle, setClusteredTitle] = useState("")
  const [newListTitle, setNewListTitle] = useState("")
  const [questionType, setQuestionType] = useState("")
  const [reportPathListId, setReportPathListId] = useState("")
  const [initialComponents, setInitialComponents] = useState([])
  const [selectedData, setSelectedData] = useState([])
  const [componentType, setComponentType] = useState([])
  const [reportChartList, setReportChartList] = useState([])
  const [clusteredPathTopics, setClusteredPathTopics] = useState([])
  const [selected, setSelected] = useState([])
  const [formValues, setFormValues] = useState({})
  const [modalIsOpen, setModalIsOpen] = useState({
    newClusteredIsOpen: false,
    newListIsOpen: false,
    newPathTopicsIsOpen: false,
  })
  const [reportPathImage, setReportPathImage] = useState({})
  const [showInputClustered, setShowInputClustered] = useState(false)
  const [reloadData, setReloadData] = useState(false)
  const [uploadedImage, setUploadedImage] = useState(false)
  const [loading, setLoading] = useState(false)
  const [processingFile, setProcessingFile] = useState(false)
  const [updateLabelInput, setUpdateLabelInput] = useState("Titulo do Agrupamento")

  const {
    register,
    resetField,
    watch,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({
    mode: "onChange",
  })

  useEffect(() => {
    setValue("")
    setInitialComponents([])
  }, [scope?.id])

  useEffect(() => {
    loadReportChartList()
  }, [scope?.id, reloadData])

  useEffect(() => {
    if (selectedData.length > 0) {
      setInitialComponents(
        formatCharts(formartDataToFix(selectedData, dw, false), questionValue, scope?.id, true),
      )
    }
  }, [selectedData])

  const linkImageFieldWatch = watch("linkImage")

  useEffect(() => {
    if (linkImageFieldWatch?.length && isValidURL(linkImageFieldWatch)) {
      setReportPathImage({})
      setUploadedImage(false)
    }
    return
  }, [linkImageFieldWatch])

  useEffect(() => {
    if (uploadedImage) {
      resetField(uploadedImage && "linkImage", { keepError: false })
    }
    return
  }, [uploadedImage])

  const onChangeFile = (e) => {
    const files = e.target.files
    const fileReader = new FileReader()

    fileReader.fileName = files[0]?.name
    fileReader.readAsDataURL(files[0])

    fileReader.onload = (event) => {
      const fileName = event.target?.fileName || ""
      const newDataFile = { data: event.target.result, type: fileName.split(".").pop() }

      setReportPathImage(newDataFile)
      setUploadedImage(true)
    }
    e.target.value = null
  }

  const onChangeFixedComponent = (item) => {
    setComponentType(item)
    setModalIsOpen({ newClusteredIsOpen: true })
  }

  const handleOnSelect = async (data) => {
    const { label, details, projectId, value } = data

    const { form, type } = details[0]

    setValue(data)
    setQuestionType(type)
    setQuestionValue(label || "")
    setFormValues({
      formId: form.id,
      questionId: value,
      question: label,
    })

    const dwContentData = await getDwContentData(label?.split(":")[1], form?.id, projectId)
    setSelectedData(dwContentData)
  }

  const handleChangeClusteredTitle = (e) => {
    setClusteredTitle(e.target.value)
  }

  const handleChangeNewListTitle = (e) => {
    setNewListTitle(e.target.value)
  }

  const reload = () => {
    setReloadData(!reloadData)
  }

  const loadReportChartList = async () => {
    const getReportChart = await Send.get(`/report-chart-list/project/${scope?.id}`, `scopeType=${scopeType}`)

    const transformData2 = {
      name: "Arquivos",
      id: "Arquivos/",
      toggled: true,
      children: getReportChart?.flatMap((item) => {
        return {
          name: item.title,
          id: `reportChart|${item.id}`,
          children: item.path_topics.map((item2) => {
            return {
              name: item2.title,
              id: `pathTopics|${item2.id}`,
              leaf: true,
              children: item2.clustered_charts.map((item3) => {
                return {
                  name: item3.title,
                  id: `clusteredFiles|${item3.id}`,
                  leaf: true,
                }
              }),
            }
          }),
        }
      }),
    }
    setClusteredPathTopics(transformData2)
    setReportChartList(sort(getReportChart).desc("createdAt"))
  }

  const saveOrUpdateClusteredFiles = async () => {
    const splittedId = selected?.id?.split("|")[1]

    if (selected?.id?.includes("clusteredFiles")) {
      const getReportChart = await Send.get(`/clustered-charts/${splittedId}`)
      const parseJson = JSON.parse(getReportChart?.charts)

      const checkExistsChart = parseJson.filter(
        (item) =>
          item.formId === formValues.formId &&
          item.question === formValues.question &&
          item.type === componentType,
      )

      if (checkExistsChart.length > 0) {
        customToast(
          "Já existe um gráfico deste formato salvo no agrupamento!. Por favor, selecione outro",
          "error",
        )
        return
      }

      try {
        await Send.put(`/clustered-charts/${splittedId}`, {
          order: 1,
          charts: JSON.stringify([
            { ...formValues, type: componentType },
            ...parseJson,
          ]),
        })
      } catch (error) {
        console.log(error)
      }
    } else if (selected?.id?.includes("pathTopics")) {
      const checkExistsPathName = selected.children.filter((item) => item.name === clusteredTitle)

      if (checkExistsPathName.length > 0) {
        customToast(
          "Já existe tópico com este titulo!. Por favor, insira um titulo diferente",
          "error",
        )
        return
      }

      try {
        await Send.post("/clustered-charts", {
          title: clusteredTitle,
          order: 1,
          pathTopics: splittedId,
          charts: JSON.stringify([{ ...formValues, type: componentType, projectId: scope?.id }]),
        })
      } catch (error) {
        console.log(error)
      }
    }

    setModalIsOpen({ newClusteredIsOpen: false })
    reload()

    clearFields(resetField)
  }

  const saveNewListReportChart = async (data) => {
    const { title, linkImage, description, order } = data

    setLoading(true)

    let imageUpload = ""

    if (reportPathImage?.data) {
      setProcessingFile(true)
      imageUpload = await useUploadFile(reportPathImage?.data, setErrorImage, reportPathImage?.type)
      setProcessingFile(false)
    }

    try {
      await Send.post("/report-chart-list", {
        title,
        image: linkImage || imageUpload,
        order,
        description,
        projectId: scope?.id,
      })
      setModalIsOpen({ newListIsOpen: false })
      setLoading(false)
    } catch (error) {
      //setErrorSave("Erro ao salvar")
    }

    clearFields(resetField)

    reload()
  }

  useEffect(() => {
    if (selected) {
      if (selected?.id?.includes("pathTopics") || selected?.id?.includes("clusteredFiles")) {
        setShowInputClustered(true)
        if (selected?.id?.includes("clusteredFiles")) {
          setUpdateLabelInput("Agregar Gráfico")
        } else {
          setUpdateLabelInput("Titulo do Agrupamento")
        }
      } else {
        setShowInputClustered(false)
      }
    }
  }, [selected])

  const goToReports = (id) => {
    navigate(`/assistance/analysis/reports/${id}`)

    dispatch(
      setData({
        reportPathListSelectedId: id,
      }),
    )
  }

  const newPathTopicsOpenModal = (id) => {
    setModalIsOpen({ newPathTopicsIsOpen: true })
    setReportPathListId(id)
  }

  return (
    <AssistanceAnalysisScreen
      {...{
        initialComponents,
        questionType,
        handleOnSelect,
        value,
        loadOptions,
        reportChartList,
        reportPathListSelectedId,
        saveOrUpdateClusteredFiles,
        clusteredPathTopics,
        setSelected,
        onChangeFixedComponent,
        goToReports,
        showInputClustered,
        handleChangeClusteredTitle,
        handleChangeNewListTitle,
        register,
        errors,
        uploadedImage,
        onChangeFile,
        loading,
        processingFile,
        newPathTopicsOpenModal,
        modalIsOpen,
        setModalIsOpen,
        updateLabelInput,
        reload,
      }}
      onSaveReportListPath={handleSubmit(saveNewListReportChart)}
    />
  )
}

export default AssistanceAnalysisContainer
